import { useRecoilState, useRecoilValue } from 'recoil'

import {   chatDialogStartAtom, ResultBoard } from '../ResultBoard'
import style from './welcome.module.css'
import bgtImg from '../../assets/backgroundt.png'
import bgiImg from '../../assets/backgroundi.png'
import { Gallery } from '../Gallery'
import {currentCardsAtom} from '../ResultBoard/store'

function Welcome() {
	const currentCards = useRecoilValue(currentCardsAtom)
	const [chatDialogStart, ] = useRecoilState(chatDialogStartAtom)


	return (
		<div className= {currentCards==='DreamFace'?style.con:style.conI} style={{border:currentCards==='DreamFace'?'':"1px solid #e5e7eb"}}>
			{
				!chatDialogStart ? <> 
					<img alt='bg img' src={currentCards==='DreamFace'?bgtImg:bgiImg} />
					<div className={!chatDialogStart ? style.mainCon : ''}></div>					
				</> : <ResultBoard />
			}
			<div className={!chatDialogStart ? style.mainCon : ''}>
				<div className={currentCards==='DreamFace'?style.title:style.titleI}>ChatAvatar</div>
				<div style={{
					marginTop: '0.75rem',
					color:currentCards==='DreamFace'?'white':'#121317'
				}}>
					Progressive Generation Of Animatable 3D Faces
					<br />
					{currentCards==='DreamFace'?'Under Text Guidance':'From Image'}
				</div>
			</div>
			<Gallery />
		</div>
	)
}
export { Welcome }
